
import Component from '../src/components/Internal/ExternalAdUnitQuinstreet.vue';

// Register component globally without any prefix if Vue is available.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('external-ad-unit-quinstreet', Component);
}

export default Component;
    